export default "__VITE_ASSET__DzH7ei8p__"